import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

const NotFoundPage = () => {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-primary-600">404</h1>
        </div>
        
        <h2 className="text-2xl font-bold text-secondary-900 mb-4">
          Page Not Found
        </h2>
        
        <p className="text-secondary-600 mb-8">
          Sorry, we couldn't find the page you're looking for. It might have
          been moved, deleted, or you entered the wrong URL.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="bg-primary-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-primary-700 transition-colors inline-flex items-center justify-center"
          >
            <Home className="h-5 w-5 mr-2" aria-label="Home icon" />
            Go Home
          </Link>
          
          <button
            onClick={() => window.history.back()}
            className="border border-secondary-300 text-secondary-700 px-6 py-3 rounded-lg font-semibold hover:bg-secondary-50 transition-colors inline-flex items-center justify-center"
          >
            <ArrowLeft className="h-5 w-5 mr-2" aria-label="ArrowLeft icon" />
            Go Back
          </button>
        </div>
        
        <div className="mt-12">
          <p className="text-sm text-secondary-500 mb-4">
            Need help? Here are some popular pages:
          </p>
          <div className="flex flex-wrap gap-2 justify-center">
            <Link
              to="/courses"
              className="text-primary-600 hover:text-primary-700 text-sm underline"
            >
              All Courses
            </Link>
            <span className="text-secondary-300">•</span>
            <Link
              to="/about"
              className="text-primary-600 hover:text-primary-700 text-sm underline"
            >
              About Us
            </Link>
            <span className="text-secondary-300">•</span>
            <Link
              to="/contact"
              className="text-primary-600 hover:text-primary-700 text-sm underline"
            >
              Contact
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;